<template>
    <div class="ObjectLikeButtonsWrapper">
        <slot name="dislike" :on-click="() => setStatus(-1)" :active="disliked"/>
        <slot name="like" :on-click="() => setStatus(1)" :active="liked"/>
    </div>
</template>

<script>

import {mapMutations} from "vuex";

export default {
    name: "ObjectLikeButtons",
    props: {
        id: [Number, String],
        status: Number,
    },
    computed: {
        liked() {
            return this.status === 1;
        },
        disliked() {
            return this.status === -1;
        },
    },
    methods: {
        setStatus(status) {
            if (status === +this.status) {
                status = 0;
            }
            this.setObjectLikeStatus({id: this.id, status})
        },
        ...mapMutations(['setObjectLikeStatus'])
    }
}
</script>

<style lang="scss">
.ObjectLikeButtonsWrapper {

}
</style>